import { apiServiceFetch } from "../../api/apiService";
import { GameProfile } from "./GameProfile";


export class Player {
    private _id: number | undefined;
    private _username: string;
    private _password: string;
    private _email: string | undefined;
    private _gameProfile: GameProfile[] | undefined;

    public constructor(id: number | undefined, username: string, password: string, email: string | undefined, gameProfile: GameProfile[] | undefined) {
        this._id = id;
        this._username = username;
        this._password = password;
        this._email = email;
        this._gameProfile = gameProfile;
    }

    public async checkLogin(): Promise<{ result: boolean; message?: string; data?: any }> {
        try {
            const data: any = await apiServiceFetch("Player/Login", "POST", JSON.stringify({
                    username: this._username,
                    password: this._password
                }));

            if (data.id) {
                sessionStorage.setItem("player_id", String(data.id));
            }

            return { result: data.result, message: data.message}; // Adjust this based on your server response

        } catch (error) {
            console.error("An error occurred during login:", error);
            return { result: false, message: "Internal Server Error" };
        }
    }



    public async addPlayer(): Promise<void> {
        try {
            return await apiServiceFetch("Player", "POST", JSON.stringify({
                    username: this._username,
                    password: this._password,
                    email: this._email
                }));
        } catch (error) {
            console.error("There has been a problem with your fetch operation:", error);
        }
    }

    

    public async checkCredentials(): Promise<any> {
        // Make sure the input is not empty
        if (!this._email || !this._username || !this._password) {
            return { checkResult: false, message: "The input cannot be empty" };
        }

        // Check email format
        const emailRegex: RegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(this._email)) {
            return { checkResult: false, message: "E-mail format is incorrect" };
        }

        // Check password length
        if (this._password.length < 8) {
            return { checkResult: false, message: "Password length must be at least 8 characters" };
        }

        try {
            // Check if the mail exists
            const emailCheck: Response = await fetch(viteConfiguration.API_URL + "Player/checkExist/" + this._email);
            if (!emailCheck.ok) {
                throw new Error("Network response by email check was not ok.");
            }
            const emailCheckResult: any = await emailCheck.json();
            if (emailCheckResult.exists) {
                return { checkResult: false, message: emailCheckResult.message };
            }

            // Check if username exists
            const usernameCheck: Response = await fetch(viteConfiguration.API_URL + "Player/checkExist/" + this._username);
            if (!usernameCheck.ok) {
                throw new Error("Network response by username check was not ok.");
            }
            const usernameCheckResult: any = await usernameCheck.json();
            if (usernameCheckResult.exists) {
                return { checkResult: false, message: usernameCheckResult.message };
            }

            // If all checks pass, success information is returned.
            return { checkResult: true, message: "User profile passed check" };
        } catch (error) {
            console.error("Error calling API:", error);
            return { checkResult: false, message: "An error occurred while checking credentials" };
        }
    }

    public async createNewGameProfile(): Promise<void> {
        try {
            return await apiServiceFetch("GameProfile", "POST", JSON.stringify({
                    player_id: this._id
                }));
        } catch (error) {
            console.error("Error:", error);
        }
    }



    public get id(): number | undefined {
        return this._id;
    }

    public set id(value: number | undefined) {
        this._id = value;
    }

    public get username(): string {
        return this._username;
    }

    public set username(value: string) {
        this._username = value;
    }

    public get password(): string {
        return this._password;
    }

    public set password(value: string) {
        this._password = value;
    }

    public get email(): string | undefined {
        return this._email;
    }

    public set email(value: string | undefined) {
        this._email = value;
    }

    public get gameProfile(): GameProfile[] | undefined {
        return this._gameProfile;
    }

    public set gameProfile(value: GameProfile[] | undefined) {
        this._gameProfile = value;
    }
}